import CrudTab from "@/components/CrudTab";

const FIELDS = [
  { key: "name", label: "Name", type: "text" },
  { key: "active", label: "Active", type: "switch" },
];
const COLUMNS = [{ key: "name", label: "Payment method" }];

export default function PaymentMethodsTab() {
  return (
    <CrudTab table="payment_methods" singular="Payment method" prefix="payment-method" fields={FIELDS} columns={COLUMNS}
      blank={{ name: "", active: true }} />
  );
}
